import { Dispatch, Action } from "redux";
import { SelectedArtefactType } from "@emisgroup/cohort-builder-kit";
import { HttpRequest, IErrorData, IRequest } from "../../../utilities/HttpRequest";
import { ProgressSpinnerSlice } from "../../ProgressSpinner/Index";
import { handleException } from "../../../ErrorMessages/helper";
import { AppConfigSlice } from "../../AppConfig/Redux/Index";
import { IPartitionInput } from "./redux/Types";
import { PartitionListSlice } from "./index";

export const getPayLoad = (extractParam: IPartitionInput): IRequest => {
  return {
    endPoint: process.env.APP_COHORT_BUILDER,
    relativeUrl: "/applications/" + extractParam.artefactId
  };
};

export const GetPartitionList = (dispatch: Dispatch<Action>,
  extractParam: IPartitionInput): void => {
  dispatch(ProgressSpinnerSlice.actions.showProgressBar("Loading partition list..."));
  HttpRequest.get(getPayLoad(extractParam)).then((response: any) => {
    dispatch(AppConfigSlice.actions.setThresholdLimit(response.data.payload.threshold));
    dispatch(PartitionListSlice.actions.setPartitionList(response.data.payload.artefacts));
  }).catch((err: IErrorData) => {
    handleException(err, dispatch, "CommonErrMsg");
  }).finally(() => {
    dispatch(ProgressSpinnerSlice.actions.hideProgressBar());
  });
};

export const getTreePayLoad = (extractParam: SelectedArtefactType): IRequest => {
  return {
    endPoint: process.env.APP_COHORT_BUILDER,
    // eslint-disable-next-line max-len
    relativeUrl: `/artefacts/${extractParam.id}/hierarchy?level=${extractParam.level}&types=${extractParam.type}&needChildren=${extractParam.needChildren}`
  };
};
